// CartPerformance stub for optional performance tracking
const CartPerformance = {
  createStartingMarker: (name) => ({ name, start: performance.now() }),
  measure: (name, callback) => {
    if (callback) callback();
  },
  measureFromMarker: (name, marker) => {
    // Optional: Log performance metrics
    if (marker && marker.start) {
      const duration = performance.now() - marker.start;
      console.debug(`[Cart Performance] ${name}: ${duration.toFixed(2)}ms`);
    }
  },
  measureFromEvent: (name, event) => {
    // Optional: Log event-based metrics
    console.debug(`[Cart Performance] ${name}`);
  },
};

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartDrawerClearAllButton extends HTMLElement {
  constructor() {
    super();
    console.log('CartDrawerClearAllButton initialized - VERSION 2024-12-11-13:00');

    this.actions = {
      confirm: 'confirm',
      remove: 'remove',
      cancel: 'cancel',
    };

    this.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button) return;

      event.preventDefault();

      const actionWrapper = button.closest('[data-action]');
      if (!actionWrapper) {
        console.log('CartDrawer: No data-action wrapper found');
        return;
      }

      const action = actionWrapper.dataset.action;
      console.log('CartDrawer clear all clicked, action:', action);

      if (action === this.actions.confirm) {
        this.toggleConfirmation(false, true);
      } else if (action === this.actions.remove) {
        this.clearAllItems();
      } else if (action === this.actions.cancel) {
        this.toggleConfirmation(true, false);
      }
    });
  }

  toggleConfirmation(showButton, showConfirmation) {
    const button = this.querySelector('.cart__clear-all-button');
    const confirmation = this.querySelector('.cart__clear-all-confirmation');

    console.log('CartDrawer toggle - showButton:', showButton, 'showConfirmation:', showConfirmation);

    if (button) button.classList.toggle('hidden', !showButton);
    if (confirmation) confirmation.classList.toggle('hidden', !showConfirmation);
  }

  clearAllItems() {
    // Find cart-drawer-items - it's a sibling of drawer__footer
    const cartDrawer = this.closest('cart-drawer');
    const cartDrawerItems = cartDrawer ? cartDrawer.querySelector('cart-drawer-items') : null;

    if (!cartDrawerItems) {
      console.error('cart-drawer-items not found');
      return;
    }

    const cartItemsData = cartDrawerItems.dataset.cartItems;
    const itemCount = parseInt(cartDrawerItems.dataset.itemCount || '0');

    if (!cartItemsData) {
      console.error('Cart items data not found');
      return;
    }

    let variantIds;
    try {
      variantIds = JSON.parse(cartItemsData);
    } catch (e) {
      console.error('Failed to parse cart items data:', e);
      return;
    }

    // Build updates object with all variants set to 0
    const updates = {};
    variantIds.forEach((variantId) => {
      updates[variantId] = 0;
    });

    // Disable buttons and show loading
    const checkoutButton = document.getElementById('CartDrawer-Checkout');
    const allClearButtons = this.querySelectorAll('button');

    allClearButtons.forEach((btn) => (btn.disabled = true));
    if (checkoutButton) checkoutButton.disabled = true;

    const cartItemsContainer = document.getElementById('CartDrawer-CartItems');
    if (cartItemsContainer) cartItemsContainer.classList.add('cart__items--disabled');

    // Clear any existing errors
    const errorContainer = document.getElementById('CartDrawer-CartErrors');
    if (errorContainer) errorContainer.textContent = '';

    // Get sections to render and ensure cart-icon-bubble is included
    const sectionsToRender = cartDrawerItems.getSectionsToRender().map((section) => section.section);
    if (!sectionsToRender.includes('cart-icon-bubble')) {
      sectionsToRender.push('cart-icon-bubble');
    }

    const body = JSON.stringify({
      updates: updates,
      sections: sectionsToRender,
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        console.log('Cart cleared, response:', state);
        const parsedState = JSON.parse(state);

        // Update cart icon bubble - try both section wrapper and direct element
        if (parsedState.sections && parsedState.sections['cart-icon-bubble']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html');

          // Try to find the new cart-icon-bubble content
          const newCartIcon = doc.querySelector('#cart-icon-bubble');
          const currentCartIcon = document.getElementById('cart-icon-bubble');

          if (newCartIcon && currentCartIcon) {
            currentCartIcon.innerHTML = newCartIcon.innerHTML;
            console.log('Cart icon bubble updated (direct element)');
          } else {
            // Fallback: try section wrapper
            const cartIconBubbleSection = document.getElementById('shopify-section-cart-icon-bubble');
            const newContent = doc.querySelector('.shopify-section');
            if (cartIconBubbleSection && newContent) {
              cartIconBubbleSection.innerHTML = newContent.innerHTML;
              console.log('Cart icon bubble updated (section wrapper)');
            }
          }
        }

        // Refresh entire cart drawer by fetching the section again
        console.log('Fetching cart-drawer section for refresh...');
        return fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            console.log('Got cart-drawer HTML, parsing...');
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            // Replace entire drawer__inner to show empty state
            const currentDrawerInner = document.querySelector('cart-drawer .drawer__inner');
            const newDrawerInner = html.querySelector('.drawer__inner');
            console.log('Replacing drawer__inner:', { currentDrawerInner, newDrawerInner });

            if (currentDrawerInner && newDrawerInner) {
              currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
            }

            // Update cart drawer state
            const cartDrawerWrapper = document.querySelector('cart-drawer');
            if (cartDrawerWrapper) {
              cartDrawerWrapper.classList.add('is-empty');
            }

            // Announce to screen reader
            const liveRegion = document.getElementById('CartDrawer-LiveRegionText');
            if (liveRegion) {
              const message =
                itemCount === 1
                  ? window.cartStrings.cartCleared?.one || `Cart cleared. ${itemCount} item removed`
                  : window.cartStrings.cartCleared?.other || `Cart cleared. ${itemCount} items removed`;
              liveRegion.textContent = message.replace('{{ quantity }}', itemCount);
            }

            // Focus on continue shopping link
            setTimeout(() => {
              const continueShoppingLink = document.querySelector('.cart-drawer__empty-content .button');
              if (continueShoppingLink) {
                continueShoppingLink.focus();
              }
            }, 100);

            // Publish cart update event
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-drawer-clear-all',
              cartData: parsedState,
            });
          });
      })
      .catch((error) => {
        console.error('Error clearing cart:', error);

        // Show error message
        if (errorContainer) {
          errorContainer.textContent = window.cartStrings.error || 'There was an error clearing your cart.';
        }

        // Re-enable buttons
        allClearButtons.forEach((btn) => (btn.disabled = false));
        if (checkoutButton) checkoutButton.disabled = false;

        // Hide confirmation and show button again
        this.toggleConfirmation(true, false);
      })
      .finally(() => {
        // Remove loading state
        if (cartItemsContainer) cartItemsContainer.classList.remove('cart__items--disabled');
      });
  }
}

customElements.define('cart-drawer-clear-all-button', CartDrawerClearAllButton);

class CartClearAllButton extends HTMLElement {
  constructor() {
    super();

    this.actions = {
      confirm: 'confirm',
      remove: 'remove',
      cancel: 'cancel',
    };

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const button = event.target.closest('button');
      if (!button) return;

      const action = button.closest('[data-action]')?.dataset.action;
      if (!action) return;

      if (action === this.actions.confirm) {
        this.toggleConfirmation(false, true);
      } else if (action === this.actions.remove) {
        this.clearAllItems();
      } else if (action === this.actions.cancel) {
        this.toggleConfirmation(true, false);
      }
    });
  }

  toggleConfirmation(showButton, showConfirmation) {
    const button = this.querySelector('.cart__clear-all-button');
    const confirmation = this.querySelector('.cart__clear-all-confirmation');

    if (button) button.classList.toggle('hidden', !showButton);
    if (confirmation) confirmation.classList.toggle('hidden', !showConfirmation);
  }

  clearAllItems() {
    // Find cart-items - for main cart page it should be an ancestor
    const cartItems = document.querySelector('cart-items');

    if (!cartItems) {
      console.error('cart-items not found');
      return;
    }

    const cartItemsData = cartItems.dataset.cartItems;
    const itemCount = parseInt(cartItems.dataset.itemCount || '0');

    if (!cartItemsData) {
      console.error('Cart items data not found');
      return;
    }

    let variantIds;
    try {
      variantIds = JSON.parse(cartItemsData);
    } catch (e) {
      console.error('Failed to parse cart items data:', e);
      return;
    }

    // Build updates object with all variants set to 0
    const updates = {};
    variantIds.forEach((variantId) => {
      updates[variantId] = 0;
    });

    // Disable buttons and show loading
    const checkoutButton = document.querySelector('.cart__footer [name="checkout"]');
    const allClearButtons = this.querySelectorAll('button');

    allClearButtons.forEach((btn) => (btn.disabled = true));
    if (checkoutButton) checkoutButton.disabled = true;

    const cartItemsContainer = document.getElementById('main-cart-items');
    if (cartItemsContainer) cartItemsContainer.classList.add('cart__items--disabled');

    // Clear any existing errors
    const errorContainer = document.getElementById('cart-errors');
    if (errorContainer) errorContainer.textContent = '';

    const body = JSON.stringify({
      updates: updates,
      sections: cartItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        // Refresh the page to show empty state properly
        window.location.reload();
      })
      .catch((error) => {
        console.error('Error clearing cart:', error);

        // Show error message
        if (errorContainer) {
          errorContainer.textContent = window.cartStrings.error || 'There was an error clearing your cart.';
        }

        // Re-enable buttons
        allClearButtons.forEach((btn) => (btn.disabled = false));
        if (checkoutButton) checkoutButton.disabled = false;

        // Hide confirmation and show button again
        this.toggleConfirmation(true, false);
      })
      .finally(() => {
        // Remove loading state
        if (cartItemsContainer) cartItemsContainer.classList.remove('cart__items--disabled');
      });
  }
}

customElements.define('cart-clear-all-button', CartClearAllButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          // Replace entire drawer__inner to handle both empty and non-empty states
          const currentDrawerInner = document.querySelector('cart-drawer .drawer__inner');
          const newDrawerInner = html.querySelector('.drawer__inner');

          if (currentDrawerInner && newDrawerInner) {
            currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
          }

          // Update cart drawer state - remove is-empty if cart has items
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const newCartDrawerItems = document.querySelector('cart-drawer-items');
          const itemCount = parseInt(newCartDrawerItems?.dataset.itemCount || '0');

          if (cartDrawerWrapper) {
            if (itemCount === 0) {
              cartDrawerWrapper.classList.add('is-empty');
            } else {
              cartDrawerWrapper.classList.remove('is-empty');
            }
          }

          // Update cart icon bubble by fetching it separately
          return fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
            .then((response) => response.text())
            .then((iconHtml) => {
              const iconParser = new DOMParser();
              const iconDoc = iconParser.parseFromString(iconHtml, 'text/html');

              // Try direct element first (cart icon embedded in header)
              const newCartIcon = iconDoc.querySelector('#cart-icon-bubble');
              const currentCartIcon = document.getElementById('cart-icon-bubble');

              if (newCartIcon && currentCartIcon) {
                currentCartIcon.innerHTML = newCartIcon.innerHTML;
              } else {
                // Fallback: section wrapper
                const newIconContent = iconDoc.querySelector('.shopify-section');
                const currentCartIconBubble = document.getElementById('shopify-section-cart-icon-bubble');
                if (newIconContent && currentCartIconBubble) {
                  currentCartIconBubble.innerHTML = newIconContent.innerHTML;
                }
              }
            });
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#shopify-section-cart-icon-bubble',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';
    const cartPerformanceUpdateMarker = CartPerformance.createStartingMarker(`${eventTarget}:user-action`);

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            // Special handling for cart-icon-bubble (embedded in header, not separate section)
            if (section.id === 'cart-icon-bubble' && parsedState.sections[section.section]) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(parsedState.sections[section.section], 'text/html');
              const newCartIcon = doc.querySelector('#cart-icon-bubble');
              const currentCartIcon = document.getElementById('cart-icon-bubble');

              if (newCartIcon && currentCartIcon) {
                currentCartIcon.innerHTML = newCartIcon.innerHTML;
                console.log('[updateQuantity] Cart icon bubble updated (direct element)');
              }
              return;
            }

            const elementToReplace =
              document.querySelector(section.selector) ||
              document.getElementById(section.id)?.querySelector(section.selector) ||
              document.getElementById(section.id);

            if (elementToReplace && parsedState.sections[section.section]) {
              const newHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              elementToReplace.innerHTML = newHTML;
            }
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        CartPerformance.measureFromMarker(`${eventTarget}:user-action`, cartPerformanceUpdateMarker);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');

    // First try to find the specific selector within the parsed HTML
    let element = parsed.querySelector(selector);

    // If not found and selector is not .shopify-section, try within .shopify-section
    if (!element && selector !== '.shopify-section') {
      const section = parsed.querySelector('.shopify-section');
      if (section) {
        element = section.querySelector(selector);
      }
    }

    // Fallback to .shopify-section itself if nothing found
    if (!element) {
      element = parsed.querySelector('.shopify-section');
    }

    return element ? element.innerHTML : '';
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).then(() =>
              CartPerformance.measureFromEvent('note-update:user-action', event)
            );
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
